import React from "react";
import {updateAccount} from "utilities/js/callouts/CalloutFactory";
import './AccountSettingsTab_Social.css';
import AccountInfoScreenCard from "./AccountInfoScreenCard";
import { showErrorToast } from "utilities/js/ToastHelper";
import Toast from '../reusable/Toast';

class AccountSettingsTab_Social extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            userInfo: this.props.userInfo,
            isPrivate: this.props.userInfo.isPrivate ? this.props.userInfo.isPrivate : '',
            disabledPrivateButton: false,
            label: 'Social Settings',
            toastMessages: []
        };           
        this.makePublic = this.makePublic.bind(this);
        this.makePrivate = this.makePrivate.bind(this);
    }
    componentDidUpdate(prevProps) {
        if(this.props.userInfo !== prevProps.userInfo){ //<---- see here
           this.setState({ userInfo: this.props.userInfo});//<---- see here
        }
     }
    makePublic(){
        this.setPrivateSetting(false);
    }

    makePrivate(){
        this.setPrivateSetting(true);
    }

    setPrivateSetting(isPrivate){
        this.props.updateSetting({isPrivate: isPrivate});
    }

    get privateSettingLabel(){
        if(this.state.userInfo.isPrivate){
            return (<div>Your account is set to <b>Private</b> </div>);
        }else{
            return (<div>Your account is set to <b>Public</b> </div>);
        }
    }

    get makePrivateButton(){
        if(!this.state.userInfo.isPrivate){
            if(this.state.disabledPrivateButton || this.props.mode === 'view'){
                return (<button label='make-private-button' className='nav-button-red' disabled>Make Private</button>)
            }else{
                return (<button label='make-private-button' className='nav-button-red' onClick={this.makePrivate}>Make Private</button>)
            }
        }else{
            if(this.state.disabledPrivateButton || this.props.mode === 'view'){
                return (<button label='make-public-button' className='nav-button' disabled>Make Public</button>)
            }else{
                return (<button label='make-public-button' className='nav-button' onClick={this.makePublic}>Make Public</button>)
            }
        }
    }

    get editButton(){
        return (<button label='make-public-button' className='nav-button' onClick={this.props.startEdit}>Change Setting</button>)
    }



    getSocialSettingsDisplay(){
        return (
            <>
                <div className="account-info-label hide-desktop">{this.state.label}</div>
                <AccountInfoScreenCard 
                    emphasis={this.props.mode === 'edit'}
                    label={this.privateSettingLabel} 
                    content={(<div className="screen-card-subtext">Making an account private will prevent users from following you</div>)}
                    actions={this.makePrivateButton}
                ></AccountInfoScreenCard>

            </>

        );
    }

    render(){

        return (
            <>
                {this.getSocialSettingsDisplay()}  
                
            </>
        );
    }
}

export default AccountSettingsTab_Social;
